import type { ComponentType } from "react";
import { ROUTES } from "~/utils/routing/routeUtils";
import { WelcomeJourneySection } from "./WelcomeJourneySection";
import { AssetsJourneySection } from "./AssetsJourneySection";
import { PeopleJourneySection } from "./PeopleJourneySection";
import { LeasesJourneySection } from "./LeasesJourneySection";
import { MoneyJourneySection } from "./MoneyJourneySection";
import { OpsJourneySection } from "./OpsJourneySection";
import { TeamJourneySection } from "./TeamJourneySection";
import type {
  JourneySectionKey,
  JourneySectionTitleKey,
} from "./journeySectionTypes";

export type {
  JourneySectionKey,
  JourneySectionTitleKey,
} from "./journeySectionTypes";

export interface JourneySectionConfig {
  key: JourneySectionKey;
  titleKey: JourneySectionTitleKey;
  showMePath: string;
  component: ComponentType<{ isMobile: boolean }>;
}

/**
 * Journey Guide section order (Explore capability themes).
 */
export const JOURNEY_SECTIONS: JourneySectionConfig[] = [
  {
    key: "welcome",
    titleKey: "JourneyGuide_Section_welcome",
    showMePath: ROUTES.home,
    component: WelcomeJourneySection,
  },
  {
    key: "assets",
    titleKey: "JourneyGuide_Section_assets",
    showMePath: ROUTES.propertyTable,
    component: AssetsJourneySection,
  },
  {
    key: "people",
    titleKey: "JourneyGuide_Section_people",
    showMePath: ROUTES.tenantTable,
    component: PeopleJourneySection,
  },
  {
    key: "leases",
    titleKey: "JourneyGuide_Section_leases",
    showMePath: ROUTES.leaseTable,
    component: LeasesJourneySection,
  },
  {
    key: "money",
    titleKey: "JourneyGuide_Section_money",
    showMePath: ROUTES.finance,
    component: MoneyJourneySection,
  },
  {
    key: "ops",
    titleKey: "JourneyGuide_Section_ops",
    showMePath: ROUTES.serviceRequest,
    component: OpsJourneySection,
  },
  {
    key: "team",
    titleKey: "JourneyGuide_Section_team",
    showMePath: ROUTES.organization,
    component: TeamJourneySection,
  },
];

export const TOTAL_JOURNEY_SECTIONS = JOURNEY_SECTIONS.length;
